import script from "./SellerProductsPage.vue?vue&type=script&setup=true&lang=ts"
export * from "./SellerProductsPage.vue?vue&type=script&setup=true&lang=ts"

import "./SellerProductsPage.scss?vue&type=style&index=0&lang=scss&external"

const __exports__ = script;

export default __exports__